import DataTable from 'react-data-table-component';
import React from 'react'
import Statusall from './statusall';
import Flowuserapprove from './flowuserapprove';
import { FaList, FaFileSignature, FaArchive, FaExclamationTriangle, FaCheck, FaCheckCircle } from "react-icons/fa";

import Actionallstatus from './actionallstatus';


const columns = [
    {
        name: 'TDS code',
        sortable: true,
        // grow: 1,
        selector: row => row.tdscode,
    },
    {
        name: 'v',
        grow: 0.5,
        // sortable: true,
        selector: row => row.revision,
    },
    {
        name: 'date',
        // grow: 1,
        sortable: true,
        selector: row => row.createdate,
    },
    // {
    //     name: 'product group',
    //     grow: 0.5,
    //     selector: row => <div>
    //         {row.productgrouptype}
    //         <div style={{ color: "red" }}>({row.createbyName})</div>
    //     </div>,
    // },
    {
        name: 'customer/product',
        grow: 2,
        selector: row => <div>
            <di>: {row.journaltype}</di>
            <div> : {row.customername}</div>
            <div> : {row.productname}</div>
            <div style={{backgroundColor:'#F0F0F0'}}> :
            {row.productgrouptype}
            <div style={{ color: "red" }}>({row.createbyName})</div>
            </div>
        </div>,
    },
    {
        name: 'film code',
        // grow: 0.5,
        selector: row => row.filmcode,
    },
    // {
    //     name: 'revision',
    //     grow: 0.2,
    //     selector: row => row.revision,
    // },
    {
        name: 'status flow',
        sortable: true,
        selector: row => <Statusall id={row.journalId} statusNow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
        // grow: 1,
    },
    {
        name: 'รออนุมัติ',
        grow: 1.5,
        selector: row => <Flowuserapprove id={row.journalId}
            stateflow={row.stateflow}
            departments={row.departments}
            accountapprove={row.accountapprove} />,
    },
    {
        name: 'job status',
        // grow: 0.5,
        selector: row => <div>{row.statusprove_Tds == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle /> proof job</label>}</div>,
    },
    {
        name: 'confirm job',
        // grow: 1,
        selector: row => <div>{row.statusConfirm == 1 && <label style={{ color: '#0e9a07' }}><FaCheckCircle />Approve</label>}</div>,
    },


];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Tablejournalallstatus = (datatable) => {
    var dataresult = datatable.datatable;

    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Tablejournalallstatus